// import Main from '@/views/main/main.vue'
// import parentView from '_c/parent-view/parent-view.vue'
import appRouter from './app';
import organizationRouter from './organization';
import contentRouter from './content';
import sys_manageRouter from './sys_manage';
import sys_monitorRouter from './sys_monitor';

export default [
    // 内容管理路由
    organizationRouter,
    contentRouter,
    sys_manageRouter,
    sys_monitorRouter,
    // 基础模块路由
    ...appRouter,
];
